import * as CONFIG from '../../../config'

export const fms_v3_fe_path = CONFIG.APP_CONFIG.FMS_V3_FE_API_GATEWAY
export const headers = {
    'Accept': '*/*',
    'Content-Type': 'application/json; charset=utf-8'
}

export const upload_headers = ({ name, type, lastModified }, date, folderType) => {

    return {
        'Content-Type': type || 'image/jpeg',
        'x-path': `images/${folderType}/${date || lastModified}/`,
        'x-file-name': encodeURIComponent(name) || 'image.jpg'
    }
}